const dynamicDescContainer = document.querySelector('#dynamic-description-container');
const dynamicBtn = document.querySelector('#dynamic-button-x');
const element = document.querySelector('.select-trigger-ext');

if (element) {

    updateDynamicContent(element, dynamicDescContainer, dynamicBtn);

    element.addEventListener('change', (event) => {
        updateDynamicContent(event.target, dynamicDescContainer, dynamicBtn);
    });
}

function updateDynamicContent( selectedOptionTrig, dynamicDescContainer, dynamicBtn) {
    const selectedOption = selectedOptionTrig.options[selectedOptionTrig.selectedIndex];
    const url = selectedOption.dataset.url;
    const desc = selectedOption.dataset.desc;

    if (dynamicDescContainer) {
        dynamicDescContainer.innerHTML = desc; 
    }
    if (dynamicBtn) {
        if (url) {
            dynamicBtn.href = url;
        }
    }
}

